import type { ReactNode } from 'react';
import MgoHeading from '@humanforce/mango-ui/dist/react/heading/index.js';
import { asMangoElement } from './mango';

const MangoHeading = asMangoElement(MgoHeading);

interface HeadingProps {
  children: ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
}

export const Heading = ({ children, className, level = 2 }: HeadingProps) => {
  return (
    <MangoHeading className={className} level={String(level)}>
      {children}
    </MangoHeading>
  );
}
